import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRoute, IRoutesInitialState, IRoutesList } from '@types';

import { initialRoutes } from './initialState';

export const routesSlice = createSlice({
    name: 'routes',
    initialState: initialRoutes(),
    reducers: {
        setRoutes(state: IRoutesInitialState, action: PayloadAction<IRoutesList>) {
            state.routesList = action.payload;
        },

        setRoute(state: IRoutesInitialState, action: PayloadAction<IRoute | null>) {
            state.route = action.payload;
        },
    },
});
